import { render, staticRenderFns } from "./NhlScoreModal.vue?vue&type=template&id=3dbe65c3&scoped=true&"
import script from "./NhlScoreModal.vue?vue&type=script&lang=js&"
export * from "./NhlScoreModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbe65c3",
  null
  
)

export default component.exports